import { SnackbarProvider } from 'notistack'
import CFDLayout from './CFDLayout'
import CustomerFacingDisplayProvider from './context/CustomerFacingDisplayProvider'

const CustomerFacingDisplayPage = () => {
    return (
        <CustomerFacingDisplayProvider>
            <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                autoHideDuration={3000}
                preventDuplicate
            >
                <CFDLayout />
            </SnackbarProvider>
        </CustomerFacingDisplayProvider>
    )
}

export default CustomerFacingDisplayPage
